<mat-chip disableRipple>
  <span class="sparro-grey-800" style="width:max-content">
    {{ filterTitle }}:
    <span class="sparro-grey-900 margin-x-2">
      {{ chosenOption }}
    </span>
  </span>
  <div [matMenuTriggerFor]="optionMenu">
    <i class="icon-arrow-down-bold cursor-pointer sparro-grey-800" [class.icon-arrow-up-bold]="showOptions"></i>
  </div>
</mat-chip>

<mat-menu class="auxiliary-filter" #optionMenu="matMenu" [xPosition]="align === 'right' ? 'before' : 'after'" yPosition="below">
  <button *ngFor="let option of options" mat-menu-item class="width-100 cursor-pointer" (click)="setSelectedOption(option)">
    {{ option }}
  </button>
</mat-menu>
